import { Routes, Route, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { LanguageProvider } from './contexts/LanguageContext'
import HomePage from './pages/HomePage'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import Imprint from './pages/Imprint'
import SplashScreen from './components/SplashScreen'

// Feature Pages
import DispoPreventionPage from './pages/features/DispoPreventionPage'
import ChartsAnalyticsPage from './pages/features/ChartsAnalyticsPage'
import AITipsPage from './pages/features/AITipsPage'
import RoastModePage from './pages/features/RoastModePage'
import HabitsScorePage from './pages/features/HabitsScorePage'
import CheckInPage from './pages/features/CheckInPage'
import AzrefyPointsPage from './pages/features/AzrefyPointsPage'

function ScrollToTopOnNavigate() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  const [showSplash, setShowSplash] = useState(false)

  useEffect(() => {
    // Show splash screen only on mobile devices and first visit
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768
    const hasSeenSplash = sessionStorage.getItem('hasSeenSplash')
    
    if (isMobile && !hasSeenSplash) {
      setShowSplash(true)
      sessionStorage.setItem('hasSeenSplash', 'true')
    }
  }, [])

  return (
    <LanguageProvider>
      {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />}
      <ScrollToTopOnNavigate />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/imprint" element={<Imprint />} />
        
        {/* Feature Pages */}
        <Route path="/features/dispo-prevention" element={<DispoPreventionPage />} />
        <Route path="/features/charts-analytics" element={<ChartsAnalyticsPage />} />
        <Route path="/features/ai-tips" element={<AITipsPage />} />
        <Route path="/features/roast-mode" element={<RoastModePage />} />
        <Route path="/features/habits-score" element={<HabitsScorePage />} />
        <Route path="/features/check-in" element={<CheckInPage />} />
        <Route path="/features/azrefy-points" element={<AzrefyPointsPage />} />
      </Routes>
    </LanguageProvider>
  )
}

export default App
